import { ComparatorProps } from '@kizi/comparator-core';

import apply from './apply';
import overview from './overview';
import startWidget from './startWidget';
import getUserInput from './getUserInput';
import checkout from './checkout';
import productComparison from './productComparison';
import summary from './summary';

export const layout: ComparatorProps['layout'] = [
  startWidget,
  getUserInput,
  overview,
  productComparison,
  summary,
  apply,
  checkout,
];
